import { render, staticRenderFns } from "./distributorPrice.vue?vue&type=template&id=21b103f1&scoped=true"
import script from "./distributorPrice.vue?vue&type=script&lang=js"
export * from "./distributorPrice.vue?vue&type=script&lang=js"
import style0 from "./distributorPrice.vue?vue&type=style&index=0&id=21b103f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b103f1",
  null
  
)

export default component.exports